module.exports = __webpack_public_path__ + "img/img-introduce.cd319531.png";